export const PROTECTED_ROUTES = ['/inventory', '/profile'];

export const isRouteProtected = (path: string) =>
  PROTECTED_ROUTES.some(route => path.includes(route));
